import { Layout } from "antd";

// import RodapeAnimado from "../components/rodape";
import Header from "../components/header";

import Footer from "../components/footer";

import Routes from "./routes";
import { useHistory } from "react-router-dom";
import { useState } from "react";

const { Content } = Layout;

export default function Root() {
  const history = useHistory();
  const [path, setPath] = useState();
  const { pathname } = history.location || {};

  history.listen((location) => {
    setPath(location.pathname);
  });

  const isFooterLogin = !path ? pathname === "/login" : path === "/login";

  history.listen((location) => {
    setPath(location.pathname);
  });

  return (
    <Layout>
      {!isFooterLogin && <Header />}

      <Content style={{ background: "#fff" }}>
        <Routes />
        <div style={{ background: "#fff" }}>
          {isFooterLogin && (
            <Footer animado={true} alturaDunas={"min(23%,11.5rem)"} />
          )}
          {!isFooterLogin && <Footer />}
        </div>
      </Content>
    </Layout>
  );
}
